import { render, staticRenderFns } from "./LoginPopup.vue?vue&type=template&id=48788e5f&scoped=true&"
import script from "./LoginPopup.vue?vue&type=script&lang=js&"
export * from "./LoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./LoginPopup.vue?vue&type=style&index=0&id=48788e5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48788e5f",
  null
  
)

export default component.exports